<!DOCTYPE html>
<template>
	<b-overlay :show="verifying" rounded="sm">
		<div role="status" aria-live="polite" class="sr-only">
			{{ verifying ? 'Uploading financial statement set, please wait...' : '' }}
		</div>
		<b-form @submit.prevent="verifyFinancialStatementSet">
			<b-form-group label="Document Name" label-for="fs-set-doc-name">
				<b-form-input id="fs-set-doc-name" type="text" v-model="documentName"
					placeholder="Document Name"/>
			</b-form-group>
			<b-form-group label="Organization Name" label-for="fs-set-org-name">
				<b-form-input id="fs-set-org-name" type="text" v-model="organizationName"
					placeholder="Organization Name" disabled/>
			</b-form-group>
			<b-form-group label="Financial statement set PDF" label-for="fs-set-file">
				<b-form-file id="fs-set-file" v-model="financialStatementSet"
					placeholder="Choose a file or drop it here..."
					drop-placeholder="Drop file here..."
					size="lg">
				</b-form-file>
			</b-form-group>
			<b-button type="submit">Verify Financial Statement Set</b-button>
		</b-form>
	</b-overlay>
</template>
<style lang="scss" scoped>
</style>
<script>
	import firebase from "firebase/compat/app";
	import "firebase/compat/auth";
	import "firebase/compat/firestore";
	import "firebase/compat/storage";
	//import QRCode from "qrcode";
	//var toBlob = require('data-uri-to-blob');

	class FinancialStatementSet {
		constructor() {
		
		}
	}
	var fsSetConverter = {
		toFirestore: function(fsSet) {
			return {
				createdDate: fsSet.createdDate,
				uploadedBy: fsSet.uploadedBy,
				documentName: fsSet.documentName,
				organizationName: fsSet.organizationName
			}
		},
		fromFirestore: function(snapshot, options) {
			const data = snapshot.data(options);
			var fsSet = new FinancialStatementSet();
				fsSet.createdDate = data.createdDate.toDate().toLocaleDateString("en-US");
				fsSet.uploadedBy = data.uploadedBy;
				fsSet.documentName = data.documentName;
				fsSet.organizationName = data.organizationName;
			return fsSet;
		}
	}

	export default {
		mounted: function() {
			var currentUserId = firebase.auth().currentUser.uid;
			firebase.firestore().collection("Users").doc(currentUserId).get()
				.then(userDocSnapshot => {
					var data = userDocSnapshot.data();

					this.organizationName = data.organizationName;
				});
		},
		methods: {
			verifyFinancialStatementSet() {
				this.verifying = true;
				//save FinancialStatementSet
				var fsSetId = null;
				var fsSet = new FinancialStatementSet();
				fsSet.createdDate = new Date();
				fsSet.uploadedBy = firebase.auth().currentUser.uid;
				fsSet.documentName = this.documentName;
				fsSet.organizationName = this.organizationName;

				//TODO: convert PDF to images
				firebase.firestore().collection("FinancialStatementSet")
					.withConverter(fsSetConverter)
					.add(fsSet).then(fsSetResult => {
						fsSetId = fsSetResult.id;
						
						return firebase.firestore().collection("FinancialStatementSet")
								.doc(fsSetId).update({
									referenceDocumentUri: fsSetId
										+ "/pre-verification/"
										+ this.financialStatementSet.name});
					}).then(() => {
						var fsSetStorageRef = fsSetId + "/pre-verification/" + this.financialStatementSet.name;
						var fsSetUploadRef = firebase.storage().ref().child(fsSetStorageRef);

						return fsSetUploadRef.put(this.financialStatementSet).then((onFulfilled, onRejected) => {
							if (onRejected) {
								return console.error("upload failed", onRejected);
							}
							
							if (onFulfilled.taskState == "SUCCESS") {
								//add label to indicate successful upload here
								return true;
							}
						});
					}).then(() => {
						this.verifying = false;
					}).catch(error => {
						this.verifying = false;
						console.error(error);
					});
			}
		},
		data() {
			return {
				financialStatementSet: null,
				documentName: null,
				organizationName: null,
				
				verifying: false
			}
		}
	}
</script>

